import { render, staticRenderFns } from "./select-role.vue?vue&type=template&id=2cb02366&scoped=true&"
import script from "./select-role.vue?vue&type=script&lang=ts&"
export * from "./select-role.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb02366",
  null
  
)

export default component.exports